import React, { useCallback, useEffect, useState, useRef } from "react"
import { changeUserPassword } from "../services/userApis"
import MyModal from "./MyModal"
import Input from "./Input"
import actionHelper from "../lib/actionHelper"
import { useAuth } from "../lib/useAuth"
import { useSocketEvent } from "../contexts/SocketContext"
import sidebarStore from "../store/sidebarStore"
import "../styles/profileStyle.css"

const ChangePasswordModal = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <span
                role="button"
                onClick={() => setIsOpen(true)}
                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-700 transition-colors text-left"
            >
                <img alt="" src="assets/icons/lock-keyhole.svg" className="user-menu__icon" />
                <span className="text-gray-200">تغییر رمز عبور</span>
            </span>

            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="300px">
                <form
                    onSubmit={(e) => {
                        e.preventDefault()
                        const form = new FormData(e.target)
                        let data = {
                            currentPassword: form.get("current-password"),
                            newPassword: form.get("new-password"),
                            newPasswordConfirm: form.get("new-password-confirm"),
                        }

                        actionHelper({
                            confirmation: {
                                label: "آیا مطمئن هستید رمز عبورتان عوض شود؟",
                                actionLabel: "تغییر",
                                color: "warning",
                            },
                            callback: () => changeUserPassword(data),
                            texts: {
                                success: "با موفقیت تغییر یافت",
                                pending: "درحال تغییر",
                            },
                        })
                    }}
                    className="mt-5 ml-3"
                >
                    <div>
                        <Input label="رمز عبور فعلی" name="current-password" placeholder="فعلی" />
                    </div>
                    <div>
                        <Input label="رمز عبور جدید" name="new-password" placeholder="جدید" />
                    </div>
                    <div>
                        <Input label="تکرار رمز عبور جدید" name="new-password-confirm" placeholder="تایید جدید" />
                    </div>
                    <button type="submit" className="styled-button w-full mt-5">
                        تغییر رمز عبور
                    </button>
                </form>
            </MyModal>
        </>
    )
}

const Navbar = () => {
    const { user, setUser, loading, logout } = useAuth()
    const collapseButtonOnClick = sidebarStore((state) => state.collapseButtonOnClick)

    const [open, setOpen] = useState(false)
    const dropdownRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside)
        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [])

    const userUpdatedHandler = useCallback((newUser) => {
        setUser((oldUser) => (oldUser.id === newUser.id ? newUser : oldUser))
    }, [])
    // Subscribe to user updates over socket
    useSocketEvent("userUpdated", userUpdatedHandler)

    // Wait for initial credentials to load
    if (loading) {
        return null
    }

    return (
        <>
            <div className="nav-gradient">
                <div className="gradient-brightness"></div>
            </div>
            <div className="navbar">
                <button onClick={collapseButtonOnClick}>
                    <img
                        alt=""
                        src="assets/icons/sidebar-collapse.svg"
                        className="w-[30px] h-[30px] rounded-full bg-gradient-to-r p-1 from-sky-400 to-emerald-400"
                    />
                </button>
                {/* <!-- <User bar --> */}

                <div className="" ref={dropdownRef} onClick={() => setOpen(!open)}>
                    <button
                        onClick={() => setOpen(!open)}
                        style={{ borderColor: "#0369a1", borderWidth: "2px" }}
                        className="flex items-center gap-2 bg-transparent text-white rounded-full px-4 py-2 shadow-md border hover:shadow-lg transition-all duration-300 hover:scale-105"
                    >
                        <svg
                            className={`w-4 h-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                        <span className="text-white font-medium">{user?.username}</span>
                        <img alt="" className="user-bar__img" src="assets/img/user-00.png" />
                    </button>
                    {open && (
                        <div className="dropdown-menu absolute left-6 mt-2 w-56 bg-gray-800 rounded-lg shadow-xl border border-gray-700 py-2 z-50">
                            <div className="w-full flex flex-col justify-center items-center gap-3 px-4 py-3 hover:bg-gray-700 transition-colors text-left">
                                <span className="text-gray-200">{user?.username}</span>
                                <div className="flex gap-2">
                                    {user?.balance.toLocaleString("en-US")}
                                    <img alt="" src="assets/icons/coin.svg" className="user-menu__icon" />
                                </div>
                            </div>

                            <div className="my-2 border-t border-gray-700"></div>

                            <ChangePasswordModal />
                            <button
                                onClick={logout}
                                className="w-full flex items-center gap-3 px-4 py-3 hover:bg-red-900/30 transition-colors text-left"
                            >
                                <img alt="" src="assets/icons/person-to-door.svg" className="user-menu__icon" />
                                <span className="text-red-400 font-medium">خروج</span>
                            </button>
                        </div>
                    )}
                    {/* {open && (
                        <div className="dropdown-menu">
                            <span className="">
                                <span>{user?.balance?.toLocaleString("en-US")} تومان</span>
                                <img                         alt=""
 className="" src="assets/icons/coin-front.svg" />
                            </span>
                            <div className="user-bar__user-menu" id="user-menu">

                                <span role="button" onClick={signOutHandler} className="user-menu__item exit">
                                    <img                         alt=""
 src="assets/icons/person-to-door.svg" className="user-menu__icon" />
                                    <button>خروج</button>
                                </span>
                            </div>
                        </div>
                    )} */}
                </div>
            </div>
        </>
    )
}

export default Navbar
